import { CustomQuestion, CustomQuestionScope } from '@kouto/types';

const hasParticipantOrCustomQuestion = (customQuestions?: CustomQuestion[]) => {
  if (!customQuestions) {
    return { hasCustomQuestions: false, askParticipantsInfo: false };
  }

  // has custom questions if one question is not default and active
  const hasCustomQuestions = customQuestions.some(
    (q) => !q.config.isDefault && q.config.isActive,
  );

  // We ask for participant info if any question has scope participant
  const askParticipantsInfo = customQuestions.some(
    (q) => q.config.scope === CustomQuestionScope.PARTICIPANT,
  );

  return { hasCustomQuestions, askParticipantsInfo };
};

export default hasParticipantOrCustomQuestion;
